export const enum PropertyReportStatsTealiumEventEnum {
  REASON_SELECT = 'report_property_reason_select',
  USER_TYPE_SELECT = 'report_property_user_type_select',
  SEND = 'report_property_send',
  MY_LISTING_TOGGLE_SWITCH = 'report_property_my_listing_toggle_switch',
  VALIDATION_SUCCESS = 'claim_transaction_validation_success',
  VALIDATION_FAIL = 'claim_transaction_validation_fail',
  UPLOAD_SUCCESS = 'claim_transaction_doc_upload_success',
  UPLOAD_FAIL = 'claim_transaction_doc_upload_fail',
  REQUEST_SUCCESS = 'claim_transaction_request_success',
  REQUEST_FAIL = 'claim_transaction_request_fail',
}
